<template>
  <v-container class="c-notices app-bg">
    <v-layout column v-if="value">
      <v-flex v-if="value.clauses">
        <h3>产品条款</h3>
        <TK :code="value.code"></TK>
      </v-flex>
      <v-flex v-for="item in value.notices" :key="item.name">
        <h3>{{ item.name }}</h3>
        <ol v-if="isArray(item.content)">
          <li v-for="(item2,index2) in item.content" :key="index2">
            <template v-if="typeof item2 === 'object'">
              <span v-html="item2.name"></span>
              <ol v-if="item2.content">
                <li v-for="(item3,index3) in item2.content" :key="index3" v-html="item3"></li>
              </ol>
            </template>
            <span v-else v-html="item2"></span>
          </li>
        </ol>
        <div v-else-if="typeof item.content === 'object'">
          <span v-html="item.content.name"></span>
          <ol v-if="item.content.content">
            <li v-for="(item2,index2) in item.content.content" :key="index2" v-html="item2"></li>
          </ol>
        </div>
        <p v-else v-html="item.content"></p>
      </v-flex>
    </v-layout>
    <CategoryFind v-model="categoryVisible"></CategoryFind>
  </v-container>
</template>

<script>
import TK from "@/components/Product/TK";
import CategoryFind from "@/components/Order/CategoryFind";
export default {
  components: {
    TK,
    CategoryFind
  },
  props: {
    value: Object
  },
  data() {
    return {
      categoryVisible: false
    };
  },
  watch: {
    "$route.hash"() {
      this.categoryVisible = true;
    },
    categoryVisible() {
      if (this.$route.hash === "#jobcategory") {
        this.$router.back();
      }
    }
  },
  methods: {
    isArray(val) {
      return Object.prototype.toString.call(val) === "[object Array]";
    }
  }
};
</script>

<style lang="scss" scoped>
.c-notices {
  h3 {
    margin: 20px 0 5px;
  }
  ol {
    padding-left: 1em;
    counter-reset: a;
    li:before {
      counter-increment: a;
      content: counters(a, ".") ". ";
    }
  }
}
</style>

